import { AxiosServer, ArrRemoveSubItem, AxiosEsb } from '../../utils';
import { message } from 'antd';

let namespace = 'clientpending_';

//直接dispatch 为同步方法，比如  dispatch({type:'login/set',payload:{loading:false}});
//store 使用了thunk中间件，以下方法均为异步加载。

const clientPendingAc = {
	SET: (value) => (dispatch, getState) => {

		dispatch({ type: namespace + 'forcedUpdate', payload: value })
	},

	GET: (value) => (dispatch, getState) => {
		let store = getState().clientPendingRd;
		let { dataFetchProps, pagination } = store;
		let { current: currentPage, pageSize } = pagination;

		// 获得有效搜索选项
		let validDataFetchProps = {};
		for (const key in {...dataFetchProps, ...value}) {
			const v = value[key];
			v && (validDataFetchProps[key] = v);
		}

		dataFetchProps = { ...validDataFetchProps, currentPage, pageSize }
		console.log(dataFetchProps);
		let Axios = AxiosServer();
		return Axios.post('/client/findAll', dataFetchProps).then((res) => {

			if (res.data.status == true) {
				pagination = { ...pagination, total: res.data.count }
				dispatch({ type: namespace + 'forcedUpdate', payload: { data: res.data.data, pagination: pagination, dataLoading: false } });  // 翻页的时候，先更新 dataLoading: true
				return '刷新成功'
			} else {
				dispatch({ type: namespace + 'forcedUpdate', payload: { dataLoading: false } });
				return '刷新失败'
			}

		}).catch((err) => {
			message.error('userlist ' + err, 10);
			dispatch({ type: namespace + 'forcedUpdate', payload: { dataLoading: false } });
			return '错误'
		})
	},


	UPDATE: (value, selectedRowIndex = null) => (dispatch, getState) => {
		//可以多次dispatch(), value 是传过来的参数,  getState() 可获取当前store的状态	
		//dispatch({type:'login/set',payload:{loading:true}});
		//value 是传过来的参数
		//getState 可获取当前store的状态
		//强转id为数字，规免出错

		value.id = parseInt(value.id);
		let Axios = AxiosServer();
		return Axios.post('/client/update', value).then((res) => {

			dispatch({ type: namespace + 'updateDataById', payload: { id: value.id, data: res.data.data, selectedRowIndex } });
			//   dispatch(userlist_GET({order:[['id']]}));
			return '更新成功'
		}).catch((err) => {
			//dispatch({type:'login/set',payload:{loading:false}});
			console.log('err:', err);
			return 'error'
		})
	},
	UPDATE1: (value, selectedRowIndex) => (dispatch, getState) => {
		value.id = parseInt(value.id);
		let Axios = AxiosServer();
		return Axios.post('/client/update', value).then((res) => {
			dispatch({ type: namespace + 'updateDataById', payload: { id: value.id, data: res.data.data, selectedRowIndex } });
			dispatch({ type: namespace + 'RemoveDataByIndex', payload: { selectedRowIndex } });
			//   dispatch(userlist_GET({order:[['id']]}));
			return '更新成功'
		}).catch((err) => {
			//dispatch({type:'login/set',payload:{loading:false}});
			console.log('err:', err);
			return err.message ? err.message : err;
		})
	},

	NoticeSAP: (value) => (dispatch, getState) => {

		let Axios = AxiosEsb();
		console.log('value', value);
		return Axios.post('/api/sap/notice', value).then(d => {
			console.log(d);
			return '推送成功'
		}).catch((err) => {
			//dispatch({type:'login/set',payload:{loading:false}});
			console.log('err:', err.message ? err.message : err);
			return err.message ? err.message : err;
		})
	},
	QUERYFORSAPNO: (value) => () => {

		let Axios = AxiosEsb();
		console.log('value', value);
		return Axios.post('/api/sap/queryLimtForSapNo', value).then(d => {
			console.log(d);
			return '推送成功'
		}).catch((err) => {
			//dispatch({type:'login/set',payload:{loading:false}});
			console.log('err:', err.message ? err.message : err);
			return err.message ? err.message : err;
		})
	}

}


export { clientPendingAc };